// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"180":"App","405":"dashboard-default"}[chunkId] || chunkId) + "." + {"167":"d0a1198c","180":"c4fcf249","266":"d0808ad0","405":"d0a1198c","580":"6c52a7e3"}[chunkId] + ".chunk.css";
};